import { useState } from "react";
import { webUrlNode } from "../../constants/appInfo";
import { useSelector } from "react-redux";

export default function AdminCreateCreditPack() {
const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
 
  const [form, setForm] = useState({
    channel: "email",
    packName: "",
    credits: "",
    amountPaise: "",
    isActive: "true"
  });

  async function submit() {

    if (!form.packName || !form.credits || !form.amountPaise) {
      alert("Fill all required fields");
      return;
    }

    const res = await fetch(`${webUrlNode}/api/admin/credits/packs?appToken=${appToken}&currentToken=${currentToken}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      
      body: JSON.stringify({
        channel: form.channel,
        packName: form.packName,
        credits: Number(form.credits),
        amountPaise: Number(form.amountPaise),
        isActive: form.isActive
      })
    });

    if (!res.ok) {
      const e = await res.json();
      alert(e?.error || "Failed");
      return;
    }

    alert("Pack created");

    setForm({
      channel: "email",
      packName: "",
      credits: "",
      amountPaise: "",
      isActive: "true"
    });
  }

  return (
    <div style={styles.wrapper}>

      <h3 style={styles.heading}>Create Credit Pack</h3>

      <div style={styles.grid}>

        {/* Channel */}
        <div style={styles.field}>
          <label style={styles.label}>Channel</label>
          <select
            style={styles.input}
            value={form.channel}
            onChange={e =>
              setForm({ ...form, channel: e.target.value })
            }
          >
            <option value="email">Email</option>
            <option value="sms">SMS</option>
            <option value="whatsapp">WhatsApp</option>
            <option value="push">Push</option>
            <option value="ai">AI</option>
          </select>
        </div>

        {/* Pack Name */}
        <div style={styles.field}>
          <label style={styles.label}>Pack Name</label>
          <input
            style={styles.input}
            value={form.packName}
            onChange={e =>
              setForm({ ...form, packName: e.target.value })
            }
          />
        </div>

        {/* Credits */}
        <div style={styles.field}>
          <label style={styles.label}>Credits</label>
          <input
            type="number"
            style={styles.input}
            value={form.credits}
            onChange={e =>
              setForm({ ...form, credits: e.target.value })
            }
          />
        </div>

        {/* Amount */}
        <div style={styles.field}>
          <label style={styles.label}>Amount (₹)</label>
          <input
            type="number"
            style={styles.input}
            value={form.amountPaise}
            onChange={e =>
              setForm({ ...form, amountPaise: e.target.value })
            }
          />
          <small style={styles.helper}>
            Enter value in paise (e.g., 19900 = ₹199)
          </small>
        </div>

        {/* Active */}
        <div style={styles.field}>
          <label style={styles.label}>Active</label>
          <select
            style={styles.input}
            value={form.isActive}
            onChange={e =>
              setForm({ ...form, isActive: e.target.value })
            }
          >
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>

      </div>

      <button style={styles.button} onClick={submit}>
        Create Pack
      </button>

    </div>
  );
}const styles = {
  wrapper: {
    background: "#ffffff",
    padding: 24,
    borderRadius: 14,
    boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
    maxWidth: 700,
    margin: "auto",
    fontFamily: "Inter, sans-serif"
  },

  heading: {
    marginBottom: 20,
    fontSize: 20,
    fontWeight: 700
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: 16
  },

  field: {
    display: "flex",
    flexDirection: "column"
  },

  label: {
    marginBottom: 6,
    fontSize: 13,
    fontWeight: 600,
    color: "#475569"
  },

  input: {
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    fontSize: 14,
    outline: "none"
  },

  helper: {
    marginTop: 4,
    fontSize: 11,
    color: "#94a3b8"
  },

  button: {
    marginTop: 20,
    padding: "10px 18px",
    borderRadius: 10,
    border: "none",
    background: "#4f46e5",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer",
    width: "100%"
  }
};
